import { CenterFeedPlacement, FeedOptions } from '@/types/models'

export const addNearbyHeader = ({ feed }: { feed: CenterFeedPlacement[] }) => {
  const nearbyItems = feed.filter(
    (item) => item.feedType === FeedOptions.Nearby
  )

  if (!nearbyItems.length) {
    return feed
  }

  const firstNearbyItem = nearbyItems[0].feedPosition

  const nearbyHeader = {
    feedType: FeedOptions.NearbyHeader,
    title: 'Nearby',
    feedPosition: firstNearbyItem
  }

  return feed
    .slice(0, firstNearbyItem)
    .concat(nearbyHeader as CenterFeedPlacement)
    .concat(feed.slice(firstNearbyItem))
}
